import gql from 'graphql-tag';
import { ConsentSchema } from '../../definitions/schemas';
import Interface from '../Interface';

interface ConsentInput {
  organizationId: string;
}

interface GetConsentData {
  consent: ConsentSchema;
}

export default class ConsentInterface extends Interface {
  public async consent(variables: ConsentInput) {
    const response = await this.query<GetConsentData>(
      () =>
        this.apolloService.executeQuery<GetConsentData>({
          query: gql`
            query consent($organizationId: ID!) {
              consent(organizationId: $organizationId) {
                displayConsent
              }
            }
          `,
          variables,
        }),
      'Error loading consent'
    );

    return response.consent;
  }
}
